import { useEffect, useState, useContext } from "react"
import { Box, Chip, Grid, IconButton, Typography } from "@mui/material"
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { ButtonBasic, TableBase } from "../../components"
import { showModal } from "react-redux-modal-provider";
import { SocketContext } from "../../context/SocketContext";
import ModalNivelAdministrativo from "../../modals/admTicket/ModalNivelAdministrativo";
import NivelAdmTkService from "../../services/nivelAdmTicket.service";
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import ConfirmationDialog from "../../modals/default/ConfirmationDialog";
import { useTheme } from '@mui/material/styles';

const NivelAdministrativoScreen = () => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [items, setItems] = useState([]);
    const { sockets } = useContext( SocketContext );
    const actualizar = async() =>{
        await NivelAdmTkService.getAll({all: true}).then((resp)=>{
            setItems(resp)
        })
    }

    const columns = [
        {
            name: "id_natk",
            label: "ID",
            options: {
                filter: false,
                sort: false,
                display:false,
                viewColumns: false
            }
        },
        {
            name: "nombre_natk",
            label: "Nombre",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "cadenaSubTipo",
            label: "SubTipos",
            options: {
                filter: false,
                sort: false,
            }
        },
        {
            name: 'isDeleted_natk',
            label: "Estado",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    if(!value){
                    return <Chip label="Activo" color="success" />
                    }
                    return <Chip label="Inactivo" color="error" />
                }
            }
        },
        {
            name: 'actions',
            label: "Acciones",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <>
                        <Box display='flex'>
                            <IconButton aria-label="edit" onClick={()=>onOpenEditar(tableMeta.rowData[0])}>
                                <EditIcon fontSize="medium" sx={{color: isDarkMode ? '#90caf9' : '#0364ff'}} />
                            </IconButton>
                            <IconButton aria-label="edit" onClick={()=>onEliminar(tableMeta.rowData[0])}>
                                { !tableMeta.rowData[3] ?(
                                    <DeleteIcon fontSize="medium" sx={{color: isDarkMode ? '#f87171' : '#e01010'}} />
                                ):(
                                    <PublishedWithChangesIcon fontSize="medium" sx={{color: isDarkMode ? '#4ade80' : '#018155'}} />
                                )}
                            </IconButton>
                        </Box>
                    </>
                )
            }
        }
    ];
    const onGuardar = () => {
        actualizar()
        sockets?.emit('refreshSlice', 'nivelAdmTK');
    };
    const onOpenEditar = (item) => {
        if(item){
            const searchItem = items.find((sItem)=> sItem.id_natk === item)
            showModal(ModalNivelAdministrativo, {item: searchItem, onGuardar: onGuardar});
        }else{
            showModal(ModalNivelAdministrativo, {onGuardar: onGuardar});
        }
    };
    const onEliminar = (item) => {
        const searchItem = items.find((sItem)=> sItem.id_natk === item)
        showModal(ConfirmationDialog, {
            title: `${searchItem?.isDeleted_natk ? 'Activar' : 'Eliminar'} el Nivel Administrativo del Ticket`,
            message: `¿Esta seguro que desea ${searchItem?.isDeleted_natk ? 'activar' : 'eliminar'} el Nivel Administrativo del Ticket?`,
            onConfirm: () => {
                NivelAdmTkService.destroy(searchItem.id_natk).then(() => {
                    onGuardar();
                });
            }
        });
    };
    useEffect(() => {
        actualizar();
        document.title = 'Nivel Administrativo';
    }, [])

    return (
        <Box sx={{width:'100%',height: '100%',overflow:'auto', bgcolor: isDarkMode ? '#1a2332' : '#f5f5f5'}}>
            <Grid container p={3} display='flex' justifyContent='center'>
                <Grid item xs={6}>
                    <Typography variant="h2" sx={{color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold'}}>Nivel Administrativo del Ticket</Typography>
                </Grid>
                <Grid item xs={6} sx={{display: 'flex', justifyContent: 'end'}}>
                    <ButtonBasic
                        textButton="NUEVO"
                        sx={{width: 200, height: 30}}
                        onClick={()=>onOpenEditar()}
                        variant='wk'
                        color="nextStep"
                    />
                </Grid>
                <Grid item xs={12} md={10} mt={2} sx={{marginBottom: 15}}>
                    <TableBase title='Resultados' columns={columns} data={items} />
                </Grid>
            </Grid>
        </Box>
    )
}

export default NivelAdministrativoScreen